import classNames from 'classnames';
import { useState, useEffect, useRef, cloneElement } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import arrowLeft from '../../assets/img/arrow-long-left.svg';
import arrowRight from '../../assets/img/arrow-long-right.svg';
import { getIndexCarusel, setIndexCarusel } from '../../redux/slices/checklistStudentSlice';
import './style.scss';

const CarouselStudent = ({ children }) => {
  const dispatch = useDispatch();
  // const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const currentItemIndex = useSelector(getIndexCarusel);
  // const [duplicateSecondSlide, setDuplicateSecondSlide] = useState(false);
  const [slideList, setSlideList] = useState(children);

  const carouselItems = children.map((child, index) => {
    const itemClasses = index === currentItemIndex ? 'item active' : 'item';
    return <div className={itemClasses}>{child}</div>;
  });

  const itemCount = carouselItems.length;

  const changeTo = index => () => {
    const dispatchItem = index < 0 ? slideList.length - 1 : Math.abs(index % slideList.length);
    dispatch(setIndexCarusel(dispatchItem));
    // setCurrentItemIndex(() =>
    //   index < 0 ? slideList.length - 1 : Math.abs(index % slideList.length),
    // );
  };

  const addNewSlide = () => {
    const newSlide = cloneElement(slideList[1], { key: slideList.length });

    setSlideList(prevSlides => [...prevSlides, newSlide]);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleArrowClick = indexChange => () => {
    changeTo(currentItemIndex + indexChange)();
    scrollToTop();
  };

  return (
    <div className="wrap-slider">
      <div className="slider-container">
        {carouselItems}
        <button
          className={classNames('arrow left', {
            disabled: currentItemIndex === 0,
          })}
          onClick={handleArrowClick(-1)}
        >
          <img src={arrowLeft} alt="arrow left" />
        </button>
        <button className="arrow right" onClick={handleArrowClick(+1)}>
          <img src={arrowRight} alt="arrow right" />
        </button>
      </div>
    </div>
  );
};

export default CarouselStudent;
